import React, { useState, useEffect } from 'react';
import ContactTel from '../../../assets/images/s6_2_tel.png';

export default function Content() {
  const [faqItems, setFaqItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFaqItems = async () => {
    setLoading(true);
    try {
      const categoryId = 0;
      const apiUrl = `/api/faqVideo/cateId/${categoryId}`;
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('=== FAQ 응답 데이터 ===', data);

      if (data.success && data.list && data.list.length > 0) {
        const formattedFaqs = data.list.map(item => ({
          id: item.fv_no,
          question: item.fv_title || '자주 묻는 질문',
          answer: item.fv_content || '답변이 준비 중입니다.',
          isOpen: false
        }));
        setFaqItems(formattedFaqs);
      } else {

        setFaqItems([
          {
            id: 1,
            question: "자주 묻는 질문 내용입니다.",
            answer: "자주 묻는 질문 답변입니다.",
            isOpen: false
          }
        ]);
      }
    } catch (error) {
      console.error('FAQ 목록 조회 오류:', {
        message: error.message,
        stack: error.stack
      });
      
      setFaqItems([
        {
          id: 1,
          question: "자주 묻는 질문 내용입니다.",
          answer: "자주 묻는 질문 답변입니다.",
          isOpen: false
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqItems();
  }, []);

  // FAQ 토글 함수
  const toggleFaq = (id) => {
    setFaqItems(prevItems =>
      prevItems.map(item =>
        item.id === id
          ? { ...item, isOpen: !item.isOpen }
          : item
      )
    );
  };

  return (
    <>
      <div className="s6_2_content">
        <div className="center">
   
          <div className="flex-center col-flex relative mb-3">
            <p className="prt-regular fs-18 fc-888 relative s6_2_top_p">
              월-금 09:00~18:00
              <span className="fs-14">(주말 및 공휴일 휴무)</span>
            </p>

            <img
              src={ContactTel}
              alt="전화걸기"
              onClick={() => {
                if (window.innerWidth <= 767) {
                  window.location.href = 'tel:1555-3811';
                }
              }}
              style={{
                cursor: window.innerWidth <= 767 ? 'pointer' : 'default',
              }}
            />
 
          </div>
          
          <div className="row-flex-center between w-100 s6_2_top_txt pb-2 ">
            <p className="prt-bold fs-30 fc-black1">자주 묻는 질문</p>
          </div>

          {/* 로딩 표시 */}
          {loading && <div className="txt-center">로딩 중...</div>}

          {/* FAQ 아코디언 */}
          <div className="faq_accordion txt-left mb-10">
            {faqItems.length > 0 ? (
              faqItems.map((item) => (
                <div key={item.id} className="faq_item">
                  <div
                    className={`faq_question ${item.isOpen ? 'faq_active' : ''}`}
                    onClick={() => toggleFaq(item.id)}
                  >
                    <div className="faq_q_label prt-bold fs-18 fc-30">Q.</div>
                    <div className="faq_q_text prt-light fs-18 fc-30">{item.question}</div>
                    <div className="faq_arrow">
                      <svg
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={item.isOpen ? 'arrow_up' : ''}
                      >
                        <path
                          d="M1 1L7 7L13 1"
                          stroke="#888888"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  {item.isOpen && (
                    <div className="faq_answer row-flex-center ">
                      <div className="faq_a_label prt-bold fs-18 fc-005eed">A.</div>
                      <div className="faq_a_text prt-medium fs-18 fc-30">{item.answer}</div>
                    </div>
                  )}
                </div>
              ))
            ) : !loading && (
              <div className="no-data txt-center">
                <p>등록된 FAQ가 없습니다.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}